<template>
  <div>
    <h3 class="mb-3">Gerätetypen</h3>
    <div v-if="geraetetypenStatus.gettingGeratetypen">
      <b-spinner variant="dark" type="grow"></b-spinner>
    </div>
    <div v-else-if="geraetetypen.length > 0" class="mb-5 text-left">
      <b-table sticky-header="400px" striped small responsive outlined :items="geraetetypen" :fields="fields">
        <template v-slot:cell(del)="data">
          <b-button variant="danger" size="sm" @click="removeGeraetetyp(data.item.id)" class="float-right">Löschen</b-button>
        </template>
      </b-table>
    </div>
    <div v-else>
      <b-alert variant="danger">Es wurden noch keine Gerätetypen angelegt</b-alert>
    </div>

    <div class="my-3">
      <b-form @submit.prevent="makeGeraetetype(newGeraetetyp)">
        <b-form-row>
          <b-col cols="12" md="8" class="text-left">
            <b-form-input v-model="newGeraetetyp.titel" placeholder="Geraetetyp Name eingeben..." required></b-form-input>
          </b-col>
          <b-col cols="12" md="4" class="text-rigth">
            <b-button type="submit" variant="success">hinzufügen</b-button>
          </b-col>
        </b-form-row>
      </b-form>
    </div>
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
export default {
  name: 'Geraetetypen',
  computed: mapGetters(['geraetetypen', 'geraetetypenStatus']),
  methods: {
    ...mapActions(['fetchGeraetetypen', 'addGeraetetyp', 'removeGeraetetyp']),
    makeGeraetetype(newGeraetetyp) {
      this.addGeraetetyp(newGeraetetyp)
      this.newGeraetetyp = {titel: ''}
    }
  },
  data () {
    return {
      newGeraetetyp: {titel: ''},
      fields: [
        { key: 'titel', label: 'Name' },
        { key: 'del', label: ''}
      ]
    }
  },
  mounted () {
    this.fetchGeraetetypen()
  }
}
</script>

<style>

</style>